import { useCallback, useContext, useEffect, useState } from 'react';
import { getMemoizedData } from '../../../../common/utils/memo';
import UserContext from '../../../../common/utils/getContext';
import { useWidgetTranslates } from '../../../../common/utils/utils';
import { countriesPhoneLength } from '../../../../common/utils/datas';
import PhoneOption from './components/Phone/PhoneOption/PhoneOption';

export const getInputStyles = (stylers, errors, focused, disabled, minInputWidth) => {
    const getBg = (obj) => obj?.['background'] || obj?.['background-color'] || obj?.['backgroundColor'];
    const bgErrors = errors && errors.length ? getBg(stylers.inputError) || 'var(--background-error)' : false;
    const bgDisabled = disabled ? getBg(stylers.inputDisabled) || 'transparent' : false;
    const bgFocus = focused ? getBg(stylers.inputFocus) || 'var(--background-focus)' : false;
    const bgDefault = getBg(stylers.input) || 'var(--background)';

    const colorErrors = errors && errors.length ? stylers.inputError?.color || 'var(--color-error)' : false;
    const colorDisabled = disabled ? stylers.inputDisabled?.color || 'var(--color-disabled)' : false;
    const colorFocus = focused ? stylers.inputFocus?.color || 'var(--color-focus)' : false;
    const colorDefault = stylers.input?.color || 'var(--color)';

    const background = bgErrors || bgDisabled || bgFocus || bgDefault;
    const color = colorErrors || colorDisabled || colorFocus || colorDefault;

    const textAlign = stylers.input?.['text-align'] || stylers.input?.['textAlign'];
    return {
        ...(minInputWidth || {}),
        background,
        color,
        ...(textAlign ? { textAlign: textAlign } : {})
        // boxShadow: `inset 0px 9000px 0 ${background}`
    };
};
export const getPhoneLength = (selectedCountryData) => {
    const phoneLengthRes = Object.keys(countriesPhoneLength).find((count) => {
        return countriesPhoneLength[count].includes(selectedCountryData?.country?.replace('-copy', ''));
    });
    return !isNaN(Number(phoneLengthRes)) ? Number(phoneLengthRes) : 15;
};
export const phoneMask = (value, selectedCountryData) => {
    const codeIncluded = selectedCountryData?.phone_code?.includes('-');
    const cleanValue = value ? value.replace(/\D/g, '') : '';
    const symbols =
        selectedCountryData?.country === 'KZ' || 1
            ? { 0: codeIncluded ? '' : '(', 3: codeIncluded ? ' ' : ') ', 6: ' ' }
            : { 0: codeIncluded ? '' : '(', 2: codeIncluded ? ' ' : ') ', 4: ' ', 6: ' ' };

    const phoneLength = getPhoneLength(selectedCountryData);
    const countryCode = selectedCountryData?.phone_code?.replace(/\D/g, '');
    const getIsVal = cleanValue && cleanValue.startsWith(countryCode) ? cleanValue.slice(countryCode.length) : cleanValue;
    return getIsVal
        ? getIsVal.split('').reduce((acc, str, inx) => {
              if (inx + countryCode?.length >= phoneLength) {
                  return acc;
              }
              return acc + (symbols[inx] || '') + str;
          }, '')
        : '';
};
export const getConfig = (
    autocomplete,
    attribute,
    required,
    typeField,
    val,
    maxLength,
    step,
    minValue,
    readonly,
    initHandlers,
    type,
    selectedCountryData,
    changeHandler,
    pressHandler,
    showPass,
    disabled,
    fieldId,
    autofocus,
    mobile,
    maxValue
) => ({
    ...initHandlers,
    type: showPass ? 'password' : typeField ? (typeField === 'number' && !mobile ? 'text' : typeField) : 'text',
    onChange: (e) => changeHandler(e),
    onKeyPress: (e) => pressHandler(e),
    step,
    maxLength,
    readOnly: readonly,
    ...(type === 'phone-widget'
        ? {
              value: phoneMask(val, selectedCountryData)
          }
        : {
              value: val && step === 1 ? parseInt(`${val}`.replace(/[^0-9]/g, '')) : val
          }),
    id: fieldId,
    required,
    name: attribute,
    placeholder: '',
    autocomplete,
    disabled: Boolean(disabled) || false,
    min: minValue,
    max: maxValue,
    autoFocus: autofocus
});

export const useWidthOfInputWrapper = (minInputWidth, inputWrapperRef) => {
    const [resultWidth, setWidth] = useState({});
    useEffect(() => {
        setTimeout(() => {
            if (minInputWidth && inputWrapperRef.current) {
                const siblings = [...inputWrapperRef.current.parentElement.children].filter(
                    (el) => el !== inputWrapperRef.current
                );
                const siblingsWidth = siblings.reduce((acc, item) => {
                    let style = getComputedStyle(item);

                    let marginLeft = parseInt(style.marginLeft);
                    let marginRight = parseInt(style.marginRight);
                    const { width } = item.getBoundingClientRect();

                    return acc + marginLeft + width + marginRight;
                }, 0);

                let style = getComputedStyle(inputWrapperRef.current);
                let marginLeft = parseInt(style.marginLeft);
                let marginRight = parseInt(style.marginRight);
                const result = siblingsWidth + marginLeft + marginRight;
                setWidth(result ? { maxWidth: `calc(100% - ${result}px)` } : {});
            } else {
                setWidth({});
            }
        });
    }, [minInputWidth, inputWrapperRef]);
    return resultWidth;
};

export const usePhoneWidget = (isPhone, value, val, attribute, changeHandlerPhone, compStyle, inputRef, reloadCountry) => {
    const { userToken, lang, localization } = useContext(UserContext);
    const [openDropDown, setOpenDropDown] = useState(false);
    const [countries, setCountries] = useState(false);
    const [selectedCountryData, setSelectedCountryData] = useState(false);

    useEffect(() => {
        setSelectedCountryData(false);
        setCountries(false);
    }, [reloadCountry]);

    useEffect(() => {
        if (isPhone && !countries) {
            getMemoizedData('/api/v1/geonames/countries', userToken, lang).then((res) => {
                const data = res?.data?.reduce((acc, countr) => {
                    if (!countr?.phone_code) {
                        return acc;
                    }
                    if (countr.phone_code?.includes('and')) {
                        return [
                            ...acc,
                            ...countr.phone_code.split(' and ').map((code, i) => ({
                                ...countr,
                                phone_code: code,
                                country: i !== 0 ? countr.country + '-copy' : countr.country
                            }))
                        ];
                    }
                    return [...acc, countr];
                }, []);
                if (data) {
                    setCountries(data);
                    if (!value && !selectedCountryData) {
                        let resCountryData = false;
                        const matchLocale = data.find((countr) => {
                            return countr.geoname_id === localization?.country?.id;
                        });
                        if (matchLocale) {
                            resCountryData = matchLocale;
                        }
                        setSelectedCountryData(resCountryData);
                    }
                }
            });
        }
    }, [countries, isPhone, lang, localization?.country?.id, selectedCountryData, userToken, value]);

    useEffect(() => {
        if (isPhone && value && !selectedCountryData) {
            getMemoizedData('/api/v1/geonames/countries?filter[phone_code]=' + value.replace(/\D/g, ''), userToken, lang).then(
                (res) => {
                    const data = res?.data?.reduce((acc, countr) => {
                        if (!countr?.phone_code) {
                            return acc;
                        }
                        if (countr.phone_code?.includes('and')) {
                            return [
                                ...acc,
                                ...countr.phone_code.split(' and ').map((code, i) => ({
                                    ...countr,
                                    phone_code: code,
                                    country: i !== 0 ? countr.country + '-copy' : countr.country
                                }))
                            ];
                        }
                        return [...acc, countr];
                    }, []);
                    if (data) {
                        setSelectedCountryData((pre) => {
                            let resCountryData = false;
                            const cleanValue = value.replace(/\D/g, '');
                            if (pre?.phone_code && cleanValue.startsWith(pre.phone_code.replace(/\D/g, ''))) {
                                return pre;
                            }
                            const filtered = data.filter((countr) => {
                                if (!countr.phone_code) {
                                    return false;
                                }
                                if (countr.country === 'KZ') {
                                    return (
                                        cleanValue.startsWith((countr.phone_code + '6').replace(/\D/g, '')) ||
                                        cleanValue.startsWith((countr.phone_code + '7').replace(/\D/g, '')) ||
                                        cleanValue.startsWith((countr.phone_code + '3').replace(/\D/g, ''))
                                    );
                                }
                                return cleanValue.startsWith(countr.phone_code.replace(/\D/g, ''));
                            });
                            if (filtered.length === 0) {
                                resCountryData = filtered[0];
                            } else if (filtered.length) {
                                const matchLocale = filtered.find((countr) => {
                                    return countr.geoname_id === localization?.country?.id;
                                });
                                if (matchLocale) {
                                    resCountryData = matchLocale;
                                } else {
                                    const largest = filtered.reduce(
                                        (acc, countr) => {
                                            if (countr.phone_code.length > acc.phone_code.length) {
                                                return countr;
                                            }
                                            return acc;
                                        },
                                        { phone_code: '' }
                                    );
                                    resCountryData = largest;
                                }
                            }
                            return resCountryData;
                        });
                    }
                }
            );
        }
    }, [isPhone, lang, localization?.country?.id, selectedCountryData, userToken, value]);
    const handleClose = useCallback(() => setOpenDropDown(false), []);

    const transl = useWidgetTranslates('form');
    return {
        selectedCountry: selectedCountryData,
        phoneDropDown: {
            setOpenDropDown,
            isOpened: openDropDown,
            props: {
                transl,
                getOptions: { fieldsToSearch: ['phone_code', 'name'] },
                dropdownSearch: true,
                formatter: (opt, props, isOption, searchValue) => {
                    return <PhoneOption defaultProps={props} opt={opt} searchValue={searchValue} compStyle={compStyle} />;
                },
                selectHandler: (opt) => {
                    const cleanValue = val ? val.replace(/\D/g, '') : '';
                    const countryCode = selectedCountryData?.phone_code?.replace(/\D/g, '');
                    const getIsVal =
                        cleanValue && cleanValue.startsWith(countryCode) ? cleanValue.slice(countryCode.length) : cleanValue;
                    setSelectedCountryData(opt);
                    changeHandlerPhone(getIsVal, opt);
                    inputRef?.current && inputRef.current.focus();
                    handleClose();
                },
                val: selectedCountryData,
                attribute,
                loading: !countries,
                optionsList: countries || [],
                handleClose
            }
        }
    };
};
